<template>
<!-- :key="appKey" -->
  <div id="app" >
    <keep-alive :include="include">
        <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>

    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive">
    </router-view>
  </div>
</template>

<script>
import Vue from 'vue';
import { Notify } from 'vant';

Vue.use(Notify);
export default {
  name: 'App',
  data() {
    return {
      include: [],
      transitionName: 'slide-right', // 默认动态路由变化为slide-right
    };
  },
  watch: {
    $route(to, from) {
      //如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name);
      }else{
        window.scrollTo(0 ,0)
      }
      //如果 要 form(离开) 的页面是 keepAlive缓存的，
      //再根据 deepth 来判断是前进还是后退
      //如果是后退
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }
      window.scrollTo(0,0);
    },
  },
  created() {
    this.appCmdApply('closeNavigation');// 默认都关闭
    window.appVisible = function() {}
    window.pageReVisible = function() {} // 初始化 防报错
  },
  mounted() {
    window.addEventListener("offline", () => {
      Notify({ type: 'warning', message: '当前网络不可用', duration: 0 });
    });
    window.addEventListener("online", () => {
      Notify.clear()
    });
  },
};
</script>

<style lang="stylus">
// @import '~common/stylus/variable';
// @import '~common/stylus/reset';

html {
  min-height: 100vh;
}

html,body,#app{
  height: 100%;
  width: 100%;
  background: #fff;
}

.Router {
  position: absolute;
  width: 100%;
  // transition: all 0.4s ease;
}

</style>



// WEBPACK FOOTER //
// src/App.vue